<template>
  <div id="app">
    <MainComponent/>
    <div>
      <div class="lg:flex xl:flex justify-center owerflow-hidden p-8">
      <img src="../src/assets/1.jpg" alt="menu cover">
      </div>
      <div class="lg:flex xl:flex justify-center owerflow-hidden p-8">
        <img src="../src/assets/2.jpg" alt="menu page 2">
      </div>
      <div class="lg:flex xl:flex justify-center owerflow-hidden p-8">
        <img src="../src/assets/3.jpg" alt="menu page 3">
      </div>
      <div class="lg:flex xl:flex justify-center owerflow-hidden p-8">
        <img src="../src/assets/4.jpg" alt="menu page 4">
      </div>
      <div class="lg:flex xl:flex justify-center owerflow-hidden p-8">
        <img src="../src/assets/5.jpg" alt="menu page 5">
      </div>
      <div class="lg:flex xl:flex justify-center owerflow-hidden p-8">
        <img src="../src/assets/6.jpg" alt="menu page 6">
      </div>
      <div class="lg:flex xl:flex justify-center owerflow-hidden p-8">
        <img src="../src/assets/7.jpg" alt="menu page 7">
      </div>
      <div class="lg:flex xl:flex justify-center owerflow-hidden p-8">
        <img src="../src/assets/8.jpg" alt="menu page 8">
      </div>
      <div class="lg:flex xl:flex justify-center owerflow-hidden p-8">
        <img src="../src/assets/9.jpg" alt="menu page 9">
      </div>
      <div class="lg:flex xl:flex justify-center owerflow-hidden p-8">
        <img src="../src/assets/10.jpg" alt="menu page 10">
      </div>
      <div class="lg:flex xl:flex justify-center owerflow-hidden p-8">
        <img src="../src/assets/11.jpg" alt="menu page">
      </div>
       <div class="lg:flex xl:flex justify-center owerflow-hidden p-8">
        <img src="../src/assets/12.jpg" alt="menu page">
      </div>
       <div class="lg:flex xl:flex justify-center owerflow-hidden p-8">
        <img src="../src/assets/13.jpg" alt="menu page">
      </div>
       <div class="lg:flex xl:flex justify-center owerflow-hidden p-8">
        <img src="../src/assets/14.jpg" alt="menu page">
      </div>
       <div class="lg:flex xl:flex justify-center owerflow-hidden p-8">
        <img src="../src/assets/15.jpg" alt="menu page">
      </div>
       <div class="lg:flex xl:flex justify-center owerflow-hidden p-8">
        <img src="../src/assets/16.jpg" alt="menu page">
      </div>
       <div class="lg:flex xl:flex justify-center owerflow-hidden p-8">
        <img src="../src/assets/17.jpg" alt="menu page">
      </div>
       <div class="lg:flex xl:flex justify-center owerflow-hidden p-8">
        <img src="../src/assets/18.jpg" alt="menu page">
      </div>
       <div class="lg:flex xl:flex justify-center owerflow-hidden p-8">
        <img src="../src/assets/19.jpg" alt="menu page">
      </div>
       <div class="lg:flex xl:flex justify-center owerflow-hidden p-8">
        <img src="../src/assets/20.jpg" alt="menu page">
      </div>
       <div class="lg:flex xl:flex justify-center owerflow-hidden p-8">
        <img src="../src/assets/21.jpg" alt="menu page">
      </div>
       <div class="lg:flex xl:flex justify-center owerflow-hidden p-8">
        <img src="../src/assets/22.jpg" alt="menu page">
      </div>
       <div class="lg:flex xl:flex justify-center owerflow-hidden p-8">
        <img src="../src/assets/23.jpg" alt="menu page">
      </div>
      <div class="lg:flex xl:flex justify-center owerflow-hidden p-8">
        <img src="../src/assets/24.jpg" alt="menu page">
      </div>
    </div>
  </div>
</template>

<script>
import MainComponent from './components/mainComponent.vue'
export default {
  name: 'App',
  data () {
    return {
      menuStatus: 0,
    }
  },
  components: {
    MainComponent
  }
  /*async created() {
    var { data }=await axios.get("") ;
    console.log(data)
  }*/
}
</script>

<style>

</style>
